export const API_URL = 'https://api-tdrschererweb-develop.s.scherer-sa.com.br/'
